import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDVmYa2i1vtPgYW_N9QbTDdxpsWFQ3hCqY",
  authDomain: "hindflight.firebaseapp.com",
  projectId: "hindflight",
  storageBucket: "hindflight.appspot.com",
  messagingSenderId: "556664082203",
  appId: "1:556664082203:web:2c7a25ea26f7b6e998cdbe",
  measurementId: "G-LRFWG1051Y"
};
firebase.initializeApp(firebaseConfig);

// utils
const db = firebase.firestore();
const auth = firebase.auth();

// collection references
const usersCollection = db.collection("users");

// export utils/refs
export { db, auth, usersCollection };
